import React from 'react';
import { useNavigate } from 'react-router';

import { HomeNavButtonComponent } from 'baseComponents/HomeNavButtonComponent';
import { HomeNavButtonType } from 'types/componentTypes/button-wrapper-types';

import 'screens/HomeScreen/components/ButtonsWrapper/buttonsWrapper.scss';

interface Props {
  buttonsArray: HomeNavButtonType[];
}

export const ButtonsWrapper: React.FC<Props> = (props) => {
  const navigate = useNavigate();

  return (
    <div className='buttons-wrapper'>
      {props.buttonsArray.map((b) => (
        <HomeNavButtonComponent
          key={b.title}
          title={b.title}
          iconName={b.iconName}
          onClick={() => navigate(b.url)}
        />
      ))}
    </div>
  );
};
